import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToChucKhoThietBi } from 'src/app/shared/ToChucKhoThietBi.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class ToChucKhoThietBiService extends BaseService{
    list: ToChucKhoThietBi[] | undefined;
    list001: ToChucKhoThietBi[] | undefined;
    formData!: ToChucKhoThietBi;

    displayColumns001: string[] = ['STT', 'DanhMucThietBiID','SoLuong','Note', 'Save'];
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "ToChucKhoThietBi";
    }
}

